import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`

export const Title = styled.div`
    font-size: 42px;
    font-weight: 500;
    font-family: 'Poppins', sans-serif;
    margin-bottom: 2rem;

    @media (max-width: 768px) {
        font-size: 24px;
        margin-top: 2rem;
        margin-bottom: 0.5rem;
    }
`

export const CardContainer = styled.div`
    display: flex;
    width: 100%;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: auto;
        gap: 1.5rem;
        width: 90%;
    }
`

export const ButtonContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: auto;
    width: max-content;
    margin-top: 3rem;
`
